import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Divider } from '@lockerpm/design';

import {
  DownOutlined,
  RightOutlined
} from "@ant-design/icons";

import commonComponents from "../../../components/common";
import securityComponents from "./components/security";

const SettingsSecurity = (props) => {
  const { PageHeader } = commonComponents;
  const {
    ChangeAccountPassword,
    ChangeMasterPassword,
    TwoFA,
    EmergencyAccess,
    ManageSessions,
    SecurityKey,
    Passkey,
    EncryptionKeySettings
  } = securityComponents;
  const { } = props;
  const { t } = useTranslation();

  const userInfo = useSelector((state) => state.auth.userInfo);

  const UnlockMethods = () => {
    const [expand, setExpand] = useState(false);
    const currentPage = useSelector((state) => state.system.currentPage);

    useEffect(() => {
      setExpand(currentPage?.query?.change_master_password == 1)
    }, [currentPage?.query?.change_master_password])

    return (
      <div className="mt-4">
        <div className="flex justify-between">
          <div
            className="flex text-primary cursor-pointer"
            onClick={() => setExpand(!expand)}
          >
            <p className="font-semibold text-xl mr-2">
              {t('security.unlock_methods.title')}
            </p>
            {
              expand ? <DownOutlined /> : <RightOutlined />
            }
          </div>
        </div>
        <p className="mt-1">
          {t('security.unlock_methods.description')}
        </p>
        {
          expand && <div className="mt-8">
            <ChangeMasterPassword />
            <Divider />
            <SecurityKey />
            <Divider />
            <Passkey />
          </div>
        }
      </div>
    )
  }
  
  return (
    <div className="email-notifications layout-content">
      <PageHeader
        title={t('security_control.title')}
        subtitle={t('security_control.description')}
        actions={[]}
      />
      <ChangeAccountPassword className="mt-4"/>
      <Divider />
      <UnlockMethods />
      {
        userInfo?.kdf_version >= 1 && <>
          <Divider />
          <EncryptionKeySettings />
        </>
      }
      <Divider />
      <TwoFA />
      <Divider />
      <EmergencyAccess />
      <Divider />
      <ManageSessions />
      <Divider />
    </div>
  );
}

export default SettingsSecurity;